import { Routes } from '@angular/router';

import { AliasDetailComponent } from './components/pages/alias-detail/alias-detail.component';
import { AliasComponent } from './components/pages/alias/alias.component';
import { BiasingPolicyDetailComponent } from './components/pages/biasing-policy-detail/biasing-policy-detail.component';
import { BiasingPolicyComponent } from './components/pages/biasing-policy/biasing-policy.component';
import { ClientDetailComponent } from './components/pages/client-detail/client-detail.component';
import { ClientComponent } from './components/pages/client/client.component';
import { CrawlingJsonComponent } from './components/pages/crawling-json/crawling-json.component';
import { CrawlingWebDetailComponent } from './components/pages/crawling-web-detail/crawling-web-detail.component';
import { CrawlingWebComponent } from './components/pages/crawling-web/crawling-web.component';
import { DeleteDocumentComponent } from './components/pages/delete-document/delete-document.component';
import { DiagnosticsDetailComponent } from './components/pages/diagnostics-detail/diagnostics-detail.component';
import { DiagnosticsComponent } from './components/pages/diagnostics/diagnostics.component';
import { IndiciComponent } from './components/pages/indici/indici.component';
import { KeywordsNotExpandComponent } from './components/pages/keywords-not-expand/keywords-not-expand.component';
import { KeywordsToIgnoreComponent } from './components/pages/keywords-to-ignore/keywords-to-ignore.component';
import { MetaComponent } from './components/pages/meta/meta.component';
import { OneboxComponent } from './components/pages/onebox/onebox.component';
import { ReportComponent } from './components/pages/report/report.component';
import { SuggestionComponent } from './components/pages/suggestion/suggestion.component';
import { SynonymsComponent } from './components/pages/synonyms/synonyms.component';
import { UserProfileComponent } from './components/pages/user-profile/user-profile.component';
import { UsersComponent } from './components/pages/users/users.component';
import { companyRestrictionGuard } from './components/utility/company-restriction.guard';
import { roleRestrictionGuard } from './components/utility/role-restriction.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/client', pathMatch: 'full' },

  //Profilo utente
  { path: 'profile', component: UserProfileComponent, data: { breadcrumb: 'Profilo Utente' } },

  // Liste
  { path: 'client', component: ClientComponent, data: { breadcrumb: 'Client' } },
  { path: 'indici', component: IndiciComponent, data: { breadcrumb: 'Indici' } },
  { path: 'alias', component: AliasComponent, data: { breadcrumb: 'Alias' } },
  { path: 'onebox', component: OneboxComponent, data: { breadcrumb: 'Onebox' } },
  { path: 'biasing-policy', component: BiasingPolicyComponent, data: { breadcrumb: 'Biasing Policy' } },
  { path: 'suggestion', component: SuggestionComponent, data: { breadcrumb: 'Suggestion' } },
  { path: 'delete_document', component: DeleteDocumentComponent, data: { breadcrumb: 'Elimina Documento' } },
  { path: 'meta', component: MetaComponent, data: { breadcrumb: 'Meta' } },
  { path: 'diagnostica', component: DiagnosticsComponent, data: { breadcrumb: 'Diagnostica' } },
  { path: 'crawling-json-xml', component: CrawlingJsonComponent, canActivate: [companyRestrictionGuard], data: { breadcrumb: 'Crawling JSON/XML', forbiddenTenants: ['EDIDOMUS'] } },
  { path: 'crawling-web', component: CrawlingWebComponent, canActivate: [companyRestrictionGuard], data: { breadcrumb: 'Crawling Web', forbiddenTenants: ['EDIDOMUS'] } },
  { path: 'sinonimi', component: SynonymsComponent, data: { breadcrumb: 'Sinonimi' } },
  { path: 'keyword-da-ignorare', component: KeywordsToIgnoreComponent, data: { breadcrumb: 'Keyword da ignorare' } },
  { path: 'keyword-da-non-espandere', component: KeywordsNotExpandComponent, data: { breadcrumb: 'Keyword da non espandere' } },
  { path: 'reports', component: ReportComponent, data: { breadcrumb: 'Reports' } },
  { path: 'users', component: UsersComponent, canActivate: [roleRestrictionGuard], data: { breadcrumb: 'Users', roleRestriction: ['BACKOFFICE_ADMIN']}},

  // Dettagli
  {
    path: 'client/detail/:id/:name',
    component: ClientDetailComponent,
    data: {
      breadcrumb: 'Dettaglio Client',
      parent: { label: 'Client', url: '/client' }
    }
  },
  {
    path: 'alias/detail/:id/:name',
    component: AliasDetailComponent,
    data: {
      breadcrumb: 'Dettaglio Alias',
      parent: { label: 'Alias', url: '/alias' }
    }
  },
  {
    path: 'biasing-policy/detail/:id/:name',
    component: BiasingPolicyDetailComponent,
    data: {
      breadcrumb: 'Dettaglio Policy',
      parent: { label: 'Biasing Policy', url: '/biasing-policy' }
    }
  },
  {
    path: 'diagnostica/dettaglio/:id/:name',
    component: DiagnosticsDetailComponent,
    data: {
      breadcrumb: 'Dettaglio documento',
      parent: { label: 'Diagnostica', url: '/diagnostica' }
    }
  },
  {
    path: 'crawling-web/detail/:id/:name',
    component: CrawlingWebDetailComponent,
    canActivate: [companyRestrictionGuard],
    data: {
      breadcrumb: 'Dettaglio Job Schedule',
      parent: { label: 'Crawling Web', url: '/crawling-web' },
      forbiddenTenants: ['EDIDOMUS']
    }
  },

  { path: '**', redirectTo: 'client' }
];
